import { Inject, Injectable, Optional } from "@angular/core";
import { BiometrySignatureResponse } from "../models/biometric-signature";
import { BiometrySignatureRequest } from "../../../../api/model/biometrySignatureRequest";
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { BASE_PATH, Configuration } from "../../../../api";
import { Observable } from "rxjs";

@Injectable()
export class BiometryV5Service {
  public basePath = 'https://test.ivsign.net/Keyman';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
      if (basePath) {
          this.basePath = basePath;
      }
      if (configuration) {
          this.configuration = configuration;
          this.basePath = basePath || configuration.basePath || this.basePath;
      }
  }

  /**
   * Metodo que realiza una firma biometrica con un certificado preconfigurado en ivsign
   * 
   * @param request request con los datos para realizar la firma con biometria
   * @param authentication The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public biometryBiometrySign(request: BiometrySignatureRequest, authentication: string, observe?: 'body', reportProgress?: boolean): Observable<BiometrySignatureResponse>;
  public biometryBiometrySign(request: BiometrySignatureRequest, authentication: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BiometrySignatureResponse>>;
  public biometryBiometrySign(request: BiometrySignatureRequest, authentication: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BiometrySignatureResponse>>;
  public biometryBiometrySign(request: BiometrySignatureRequest, authentication: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

      if (request === null || request === undefined) {
          throw new Error('Required parameter request was null or undefined when calling biometryBiometrySign.');
      }

      if (authentication === null || authentication === undefined) {
          throw new Error('Required parameter authentication was null or undefined when calling biometryBiometrySign.');
      }

      let headers = this.defaultHeaders;
      if (authentication !== undefined && authentication !== null) {
          headers = headers.set('Authentication', String(authentication));
      }

      // to determine the Accept header
      let httpHeaderAccepts: string[] = [
          'application/json',
          'text/json',
          'application/xml',
          'text/xml'
      ];
      const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      if (httpHeaderAcceptSelected != undefined) {
          headers = headers.set('Accept', httpHeaderAcceptSelected);
      }

      // to determine the Content-Type header
      const consumes: string[] = [
          'application/json',
          'text/json',
          'application/xml',
          'text/xml',
          'application/x-www-form-urlencoded'
      ];
      const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected != undefined) {
          headers = headers.set('Content-Type', httpContentTypeSelected);
      }

      return this.httpClient.post<BiometrySignatureResponse>(`${this.basePath}/rest/v5/biometry/sign`,
          request,
          {
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }


}